// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"03493f18","787":"8142cee3"}[chunkId] + ".chunk.js";
};